"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _AvailabilityFieldPreview = _interopRequireDefault(require("../AvailabilityFieldPreview"));

function ProductListItemCardAvailabilityFieldPreview(_ref) {
  var delInfo = _ref.delInfo,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["delInfo", "product", "renderToGridArea"]);
  return /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({
    renderToGridArea: renderToGridArea
  }, rest), /*#__PURE__*/_react.default.createElement(_AvailabilityFieldPreview.default, {
    product: product,
    delInfo: delInfo
  }));
}

process.env.NODE_ENV !== "production" ? ProductListItemCardAvailabilityFieldPreview.propTypes = {
  delInfo: _propTypes.default.shape({}).isRequired,
  product: _propTypes.default.shape({}).isRequired,
  renderToGridArea: _propTypes.default.string
} : void 0;
ProductListItemCardAvailabilityFieldPreview.defaultProps = {
  renderToGridArea: 'storage'
};
var _default = ProductListItemCardAvailabilityFieldPreview;
exports.default = _default;